// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import StarHalf from '../_raw/ui/icon_star_half.svg';

export default withIconProps(StarHalf);
